@if (validateDict?.is_bathurst_validated) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
@if (validateDict?.is_maitland_newcastle_validated && validateDict?.is_maitland_newcastle_completed) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}@else if(validateDict?.is_maitland_newcastle_validated && !validateDict?.is_maitland_newcastle_completed) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  partially-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
<!-- @if(validateDict?.is_maitland_newcastle_validated) {
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
} -->
@if (validateDict?.is_edubase_validated) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
@if (validateDict?.is_canberra_goulburn_validated) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
@if (validateDict?.is_diocese_wagga_validated) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
<!-- <i *ngIf="validateDict?.is_doe_school" class="bi bi-check-circle-fill check-completed"></i> -->
@if (validateDict?.is_lismore_school) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
@if (validateDict?.is_diocese_lismore_validated) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}
@if (validateDict?.is_diocese_wagga_unverified) {
<i class="bi bi-check-circle-fill waaga-unverified ml-5"></i>
}
@if (validateDict?.is_diocese_wagga_not_employed) {
<i class="bi bi-check-circle-fill waaga-unemployed ml-5"></i>
}
@if (validateDict?.is_brisbane_validated && validateDict?.is_brisbane_complete) {
<span class="bseTooltip">
  <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
    class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
    <title>Fully Compliant</title>
    <path
      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
  <span class="bseTooltiptext text-s-m-g-1">Fully Compliant</span>
</span>
}
@if (validateDict?.is_brisbane_validated && !validateDict?.is_brisbane_complete) {
<span class="bseTooltip">
  <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
    class="bi bi-check-circle-fill bseTooltip partially-completed" viewBox="0 0 17 19">
    <title>Mandatory training incomplete</title>
    <path
      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
  <span class="bseTooltiptext text-s-m-g-1">Mandatory training incomplete</span>
</span>
}

<!-- <p class="notesTooltip  c-p fit-content add-notes mt-10">
<span class="text-regular-bold clr-cc-vilot"><i
class="bi bi-pencil-fill vertical-align-bottom fs-11 ml-5 mr-3"></i> View notes
</span>
<span class="notesTooltiptext text-s-m-g-1">Fully Compliant</span>
</p> -->
@if (validateDict?.is_validated) {
<span class="tooltips" appFocus>
  @if (validateDict?.training_completed) {
  <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
    class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
    <title>Training completed</title>
    <path
      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
  }
  @if (!validateDict?.training_completed) {
  <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
    class="bi bi-check-circle-fill  partially-completed" viewBox="0 0 17 19">
    <title>Partially completed</title>
    <path
      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
  }
  <span [ngClass]="from == 'bookingSideInviteList' ? 'tooltiptextSideInvite' : 'tooltiptext'" class="">
    <p class="mb-10">Verified with NSW Department of Education</p>
    <div class="mb-3  d-flex align-items-center">
      <span><svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
          class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
          <title>Approval to teach</title>
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </svg>
      </span>
      <span class="mt-3 ml-3"> Approval to teach </span>
    </div>
    @if (!validateDict?.training_completed) {
    <div class="mb-5  d-flex align-items-center">
      <span><svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
          class="bi bi-x-circle-fill mandatory-not-completed" viewBox="0 0 17 19">
          <title>Mandatory training incomplete</title>
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
        </svg> </span>
      <span class="mt-3 ml-3"> Mandatory Training Completed </span>
    </div>
    }
    @if (validateDict?.training_completed) {
    <div class="mb-5   d-flex align-items-center">
      <span><svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
          class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
          <title>Mandatory training completed</title>
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </svg></span>
      <span class="mt-3 ml-3"> Mandatory Training Completed</span>
    </div>
    }
    <p class="mt-10">Find out more <a role="button" appFocus appClick
        href="https://help.classcover.com.au/en/articles/45936-what-does-the-verification-tick-next-to-my-name-mean-nsw-department-of-education"
        target="_blank">here</a></p>
  </span>
</span>
}
@if (validateDict?.is_diocese_cairns_validated && validateDict?.is_diocese_cairns_completed) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}@else if(validateDict?.is_diocese_cairns_validated && !validateDict?.is_diocese_cairns_completed) {
<svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
  class="bi bi-check-circle-fill  partially-completed" viewBox="0 0 17 19">
  <path
    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
</svg>
}